import * as React from 'react';
import Modul from '../module/Modul';
import IconTextButton from './icon-text-button/IconTextButton';
import globalEvents = require('diy/util/globalEvents');

interface OpenGeneralStylesProps {
    module: Modul;
    Icon: typeof __MaterialUI.SvgIcon;
    label: string;
    key: string;
}

export default class OpenGeneralStyles extends React.Component<OpenGeneralStylesProps, {}> {
    render() {
        const Icon = this.props.Icon;
        return (
            <IconTextButton
                Icon={<Icon />}
                text={this.props.label}
                onTouchTap={this.handleTouchTap}
                useAlternativeColors={true}
                key={this.props.key}
            />
        );
    }

    private handleTouchTap = () => {
        // open theming
        const styleButton = document.getElementById('cc-sa-item-style');
        if (!styleButton) {
            return;
        }
        styleButton.click();
        // if it's coming from a module inside section, close the section editing mode
        const section = this.props.module.getParentSection();
        if (section) {
            section.onClickOutside();
        }
        // try to change the tab to be directly on the current font theme editing view
        globalEvents.one('diy-editor-theming-styleWindowLoaded', () => {
            // click the font tab. just changing it via scope.nav.changeTab does not update the top tabs as well
            const fontTab = document.querySelector('a[data-identifier=typography]') as HTMLElement;
            if (fontTab) {
                fontTab.click();
            }
            // change the view to the editing view of the main font set
            if (diy.editor && diy.editor.theming) {
                diy.editor.theming.run(function(scope: any) {
                    scope.nav.changeTab('typography', 'more');
                });
            }
        });
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/OpenGeneralStyles.tsx
 **/